import useCreatePassword from "../hooks/useCreatePassword";

export default function CreatePassword() {

  const {
    password,
    setPassword,
    handleSubmit,
    isValid,
    Button,
    Input,
    loading,
    submitting,
    authToken,
  } = useCreatePassword();

  if (
    loading ||
    !Button ||
    !Input
  ) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <div className="w-10 h-10 border-4 border-gray-300 rounded-full border-t-red-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto min-h-[30vh] flex flex-col justify-between">

      <div className="relative w-full">

        <Input
          token={authToken}
          value={password}
          onChange={setPassword}
          type="password"
          placeholder="Enter your Password"
          className="
            w-full
            h-[45px]
            md:h-[51px]
            rounded-xl
            border
            px-4
            pr-10
            text-[12px]
            md:text-[16px]
          "
        />

      </div>

      <Button
        token={authToken}
        onClick={handleSubmit}
        disabled={
          !isValid ||
          submitting
        }
        className={`w-full h-[45px] md:h-[51px] rounded-xl font-bold font-montserrat ${
          isValid &&
          !submitting
            ? "bg-[#CF0018] text-white"
            : "bg-gray-300 text-[#827C7C]"
        }`}
      >
        {submitting
          ? "Loading..."
          : "Submit"}
      </Button>

    </div>
  );
}